import React, { useState } from 'react';
import { IconButton, Popover } from '@mui/material';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import EmojiPicker, { Theme } from 'emoji-picker-react';

export default function ChatEmojiPicker({ onSelectEmoji, disabled, appTheme }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEmojiClick = (emojiData) => {
    // emojiData.emoji contains the actual native string character (e.g., "😊")
    onSelectEmoji(emojiData.emoji);
    handleClose(); // Closes picker after selection (optional)
  };

  const open = Boolean(anchorEl);
  const id = open ? 'emoji-picker-popover' : undefined;

  // Sync the emoji picker style with your theme state
  const isDarkMode = appTheme?.palette?.mode === 'dark';

  return (
    <>
      <IconButton
        aria-describedby={id}
        disabled={disabled}
        onClick={handleOpen}
        sx={{
          color: appTheme?.palette?.secondary?.[200] || 'inherit',
          "&:hover": {
            color: appTheme?.palette?.secondary?.[100],
            backgroundColor: appTheme?.palette?.primary?.main,
          },
        }}
      >
        <SentimentSatisfiedAltIcon />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              boxShadow: '0px 8px 24px rgba(0,0,0,0.15)',
              borderRadius: '8px',
              mt: -1, // Positions it cleanly right above the input bar
            }
          }
        }}
      >
        <EmojiPicker
          onEmojiClick={handleEmojiClick}
          theme={isDarkMode ? Theme.DARK : Theme.LIGHT}
          lazyLoadEmojis={true}
          searchPlaceHolder="Search emojis..."
          height={380}
          width={320}
        />
      </Popover>
    </>
  );
}
